import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiUser, FiArrowRight, FiBook } = FiIcons;

const StudentNameForm = ({ storyTitle, onSubmit }) => {
  const [name, setName] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (name.trim()) {
      onSubmit(name.trim());
    }
  };

  return (
    <motion.div
      className="max-w-md mx-auto"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.6 }}
    >
      <div className="bg-white rounded-xl shadow-lg p-8">
        <div className="text-center mb-8">
          <div 
            className="inline-flex items-center justify-center w-16 h-16 rounded-full mb-4"
            style={{ backgroundColor: '#c8d8e4' }}
          >
            <SafeIcon icon={FiBook} className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-2xl font-bold mb-2 font-rubik" style={{ color: '#2b6777' }}>
            Willkommen zu
          </h1>
          <h2 className="text-xl font-semibold font-rubik" style={{ color: '#2b6777' }}>
            {storyTitle}
          </h2>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label htmlFor="name" className="block text-sm font-medium mb-2 font-rubik" style={{ color: '#2b6777' }}>
              Geben Sie Ihren Namen ein, um zu beginnen
            </label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <SafeIcon icon={FiUser} className="h-5 w-5 text-gray-400" />
              </div>
              <input
                id="name"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-2 focus:ring-gray-400 focus:border-gray-400 font-rubik"
                style={{ color: '#2b6777' }}
                placeholder="Ihr Name"
                required
              />
            </div>
          </div>

          <motion.button
            type="submit"
            disabled={!name.trim()}
            className="w-full flex items-center justify-center space-x-2 py-3 px-4 border border-transparent text-sm font-medium rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed font-rubik"
            style={{ backgroundColor: '#c8d8e4' }}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            <span>Abenteuer starten</span>
            <SafeIcon icon={FiArrowRight} className="w-5 h-5" />
          </motion.button>
        </form>

        <div className="mt-6 text-center text-sm font-rubik" style={{ color: '#6b7280' }}>
          Ihr Name wird nur für diese Sitzung verwendet und nicht gespeichert.
        </div>
      </div>
    </motion.div>
  );
};

export default StudentNameForm;